import type { Middleware } from '@reduxjs/toolkit';

const STORAGE_KEY = 'padelMatch';

export const padelMatchPersistenceMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    if (typeof action === 'object' && action !== null && 'type' in action) {
      const { type } = action as { type: string };
      if (!type.startsWith('padelMatch/')) return result;

      if (type === 'padelMatch/resetMatch') {
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch {
          // Ignore storage errors
        }
      } else {
        try {
          const state = store.getState().padelMatch;
          localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
        } catch {
          // Ignore storage errors
        }
      }
    }

    return result;
  };
